import connect from 'components/Shared/connect';
import { getProductWidgets } from 'views/ProductPage/selector';
import cn from 'classnames';
import styles from './styles.scss';
import {
  MediaWidget,
  SplashWidget,
  IWidget,
  WidgetType,
  TopTestedWidget
} from 'models/ListViewProduct';
import { Media, OwnProps as MediaProps } from './media';
import Image from 'components/Shared/Image';
import { NO_ELEMENT } from 'utils';
import { ConfiguratorBase } from 'models/ConfiguratorBase';
import { isElfaConfigurator, getConfigurator } from 'views/ProductPage/configurators/selector';
import ElfaImages from 'views/ProductPage/configurators/elfa/elfaImages';

interface OwnProps {
  className?: string;
  mediaClassNames?: MediaProps['classNames'];
}

export interface MergedProps extends OwnProps {
  widgets?: IWidget[];
  isLargeImage: boolean;
  hideOverlayWidgets: boolean;
  configurator?: ConfiguratorBase;
  cdnUrl: string;
}

// TODO: create a widgets folder and move widgety stuff there?
const isMediaWidget = (widget: IWidget): widget is MediaWidget => widget.type === WidgetType.Media;
const isSplashWidget = (widget: IWidget): widget is SplashWidget =>
  widget.type === WidgetType.Splash;
const isTopTestedWidget = (widget: IWidget): widget is TopTestedWidget =>
  widget.type === WidgetType.TopTested;

const TOP_TESTED_CUSTOM_IMAGE_DIMENSIONS = {
  width: 254,
  height: 254
};

interface ProductWidgetProps extends IWidget, Pick<OwnProps, 'mediaClassNames'> {
  hideOverlayWidgets: boolean;
}

const ProductWidget = ({ hideOverlayWidgets, mediaClassNames, ...widget }: ProductWidgetProps) => {
  if (isMediaWidget(widget)) {
    return <Media classNames={mediaClassNames} {...widget} />;
  }

  if (isTopTestedWidget(widget) && !hideOverlayWidgets && widget.image) {
    return (
      <Image
        className={styles.topTested}
        {...widget.image}
        {...TOP_TESTED_CUSTOM_IMAGE_DIMENSIONS}
      />
    );
  }

  return NO_ELEMENT;
};

export const _ProductMedia = ({
  widgets,
  className,
  mediaClassNames,
  configurator,
  hideOverlayWidgets,
  cdnUrl
}: MergedProps) => {
  if (configurator && isElfaConfigurator(configurator)) {
    const widget = widgets?.find(isSplashWidget);
    return (
      <div className={cn(styles.productMediaWrapper, className)}>
        <ElfaImages configurator={configurator} cdnUrl={cdnUrl} widget={widget} />
      </div>
    );
  }
  return (
    <div className={cn(styles.productMediaWrapper, className)}>
      {widgets?.map(widget => (
        <ProductWidget
          {...widget}
          key={widget.type}
          hideOverlayWidgets={hideOverlayWidgets}
          mediaClassNames={mediaClassNames}
        />
      ))}
    </div>
  );
};

interface WidgetForProductMediaProps {
  widgets?: IWidget[];
}
const getWidgetsForProductMedia = ({ widgets }: WidgetForProductMediaProps) => {
  const productMediaWidgets = [WidgetType.Media, WidgetType.TopTested];

  return widgets?.filter(w => productMediaWidgets.includes(w.type));
};

export default connect<MergedProps, OwnProps>(
  ({ appShell, currentPage }) => ({
    widgets: getProductWidgets(currentPage),
    configurator: getConfigurator(currentPage),
    cdnUrl: appShell.links.cdnUrl
  }),
  undefined,
  (stateProps: MergedProps, _, ownProps) => {
    const widgetsForProductMedia = getWidgetsForProductMedia({ widgets: stateProps.widgets });
    const mediaWidget = widgetsForProductMedia?.find((w: IWidget) => w.type === WidgetType.Media);
    return {
      ...stateProps,
      ...ownProps,
      hideOverlayWidgets: !!mediaWidget && (mediaWidget as MediaWidget).isActive
    };
  }
)(_ProductMedia);
